<template>
  <circle cx="18.5" cy="18.5" r="18.5" fill="#FFED00" />
  <path
    d="M26.2077 25.125H10.7921C9.31812 25.125 8.39579 23.5307 9.1305 22.2529L16.8383 8.84799C17.5753 7.5663 19.4245 7.56629 20.1615 8.84798L27.8693 22.2529C28.604 23.5307 27.6817 25.125 26.2077 25.125Z"
    stroke="#D41B1B"
    stroke-width="1.5"
    stroke-linecap="round" />
  <path d="M18.5 13.625V17.4583" stroke="#D41B1B" stroke-width="1.5" stroke-linecap="round" />
  <path
    d="M18.5 21.3012L18.5094 21.2908"
    stroke="#D41B1B"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
</template>
